<template>
  <v-container>
    <Todos v-if="currentAuthorizationToken" :auth="currentAuthorizationToken" />
    <Login />
  </v-container>
</template>
<script setup lang="ts">
import { currentAuthorizationToken } from "../authenticationTokens";
</script>
